'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'
import { storeAcquisitionSource } from '@/lib/acquisition-capture'
import { PRODUCT_EVENTS } from '@/lib/product-analytics'
import {
  capturePublicChatCrossSell,
  capturePublicChatEvent,
  type PublicChatCrossSellTarget,
  type PublicChatSignupPlacement,
} from './funnel-events'

type SignupLinkProps = Omit<ComponentProps<typeof Link>, 'onClick'> & {
  placement: PublicChatSignupPlacement
  cta: 'signup' | 'call'
  /** Además cuenta como cross-sell (la videollamada de la landing, AC6.3). */
  crossSell?: PublicChatCrossSellTarget
}

/**
 * Un enlace que pasa por el alta. Regla única: todo destino que pase por el
 * alta es un `SignupLink`. Marca la fuente de adquisición (DD17) antes de
 * salir —la lee el `auth_*_completed`, aunque medie el OAuth o un abandono— y
 * cuenta el clic con su sitio (landing, popups del chat, tarjeta de cierre).
 */
export function SignupLink({ placement, cta, crossSell, ...link }: SignupLinkProps) {
  return (
    <Link
      {...link}
      onClick={() => {
        storeAcquisitionSource('public-chat')
        capturePublicChatEvent(PRODUCT_EVENTS.PUBLIC_CHAT_SIGNUP_CTA_CLICKED, { placement, cta })
        if (crossSell) capturePublicChatCrossSell(crossSell)
      }}
    />
  )
}
